// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhl_wx bhl_jb bhl_xl bhl_i bhl_j bhl_q bhl_vt bhl_et bhl_so bhl_sp bhl_eg","CommentsButton__icon":"il_b bhl_rz"};